import { type IFilter } from "@/interface/common.interface";
// import { logout } from '@/redux/features/UserSlice';

import React from "react";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import moment from "moment-timezone";

/**
 * common function to set cookies in react application
 * @param name name of cookie
 * @param value value to set in cookie
 */
export const setCookies = (name: string, value: string | object) => {
  Cookies.set(name, typeof value === "object" ? JSON.stringify(value) : value, {
    path: import.meta.env.VITE_PUBLIC_URL || "/",
  });
};

/**
 *
 * @param name find cookies by name
 * @returns
 */
export const getCookies = (name: string) => {
  const value = Cookies.get(name);
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

/**
 *
 * @param name Delete cookies by name
 * @returns
 */
export const deleteCookies = (name: string) => {
  Cookies.remove(name, { path: import.meta.env.VITE_PUBLIC_URL || "/" });
};

/**
 *
 * @returns reutn the saved auth token
 */
export const getToken = () => {
  const value = Cookies.get(import.meta.env.VITE_BUSINESS + "token");
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export function toFixedThree(input: string | number, fixedTo = 3) {
  return parseFloat(input.toString()).toFixed(fixedTo);
}

// export const toFixedThree = (price: any) => {
//   const amount = parseFloat(price);
//   const formattedPrice = new Intl.NumberFormat('en-BH', {
//     style: 'currency',
//     currency: 'BHD',
//     minimumFractionDigits: 3,
//   }).format(amount);
//   return formattedPrice;
// };

/**
 *
 * @param type type of toast notification
 * @param message message to show in toast notification
 */

// import { deleteToken } from 'firebase/messaging';
// import { messaging } from '@/firebase-messaging';

export const logoutUser = async () => {
  // try {
  //   const currentToken = await getToken();
  //   if (currentToken) {
  //     await deleteToken(messaging);
  //   }
  // } catch (error) {
  //   console.error("Error deleting FCM token:", error);
  // }
  deleteCookies(import.meta.env.VITE_BUSINESS + "token");
  deleteCookies(import.meta.env.VITE_BUSINESS + "role");
  deleteCookies(import.meta.env.VITE_BUSINESS + "refreshToken");
  localStorage.removeItem(`${import.meta.env.VITE_BUSINESS}fcmToken`);
  window.location.href = import.meta.env.VITE_PUBLIC_URL || "/";
  // setTimeout(() => {
  //     store.dispatch(logout());
  // }, 1000);
};

export const showToastNotification = (
  type: "success" | "danger" | "info" | "default" | "warning",
  message: string,
) => {
  const commonOptions = {
    position: "top-right" as const,
    duration: 5000,
  };

  // Create toast with close button
  const createToastWithClose = (
    toastFn: typeof toast | typeof toast.success | typeof toast.error,
    icon?: string,
  ) => {
    return toastFn(
      (t) =>
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "8px",
            },
          },
          React.createElement("span", { style: { flex: 1 } }, message),
          React.createElement(
            "button",
            {
              onClick: () => toast.dismiss(t.id),
              style: {
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                opacity: 0.7,
                padding: "0",
                marginLeft: "8px",
              },
            },
            "✕",
          ),
        ),
      { ...commonOptions, icon },
    );
  };

  switch (type) {
    case "success":
      return createToastWithClose(toast.success);

    case "danger":
      return createToastWithClose(toast.error);

    case "warning":
      return createToastWithClose(toast, "⚠️");

    case "info":
      return createToastWithClose(toast);

    case "default":
    default:
      return createToastWithClose(toast);
  }
};

let cachedDeviceId: string | null = null;

export const getDeviceId = (): string => {
  // Return the cached device ID if available
  if (cachedDeviceId !== null) {
    return cachedDeviceId;
  }

  // Attempt to retrieve an existing device ID from localStorage
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    // Use crypto.randomUUID() if available for secure UUID generation
    if (window.crypto && typeof crypto.randomUUID === "function") {
      deviceId = crypto.randomUUID();
    } else {
      // Fallback: simple UUID generator
      deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        (c: string): string => {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    }
    // Save the generated ID so that it persists across sessions
    localStorage.setItem("deviceId", deviceId);
  }

  // Cache the ID in memory for subsequent call
  cachedDeviceId = deviceId;
  return deviceId;
};

export const statusColors = (status: string) => {
  switch (status?.toLowerCase()) {
    case "online":
    case "active":
      return "green-500";
    case "offline":
    case "inactive":
      return "red-500";
    case "created":
    case "pending":
      return "blue-500";
    default:
      return "gray-500";
  }
};

export const formatDateTime = (
  date: string | null | undefined | Date,
  type = "default",
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string => {
  if (!date) return "";

  const formattedDate: Record<string, string> = {
    default: moment.utc(date).tz(timezone).format("DD MMM YYYY, HH:mm"),
    YYMMDD: moment.utc(date).tz(timezone).format("DD MMM YYYY"),
  };

  return formattedDate[type] || "";
};

export const GetFilterUrl = (filter: IFilter) => {
  return Object.entries(filter)
    .filter(
      ([_, value]) =>
        value !== "" &&
        value !== "all" &&
        value !== undefined &&
        value !== null,
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join("&");
};

export const CleanFilterParams = (filter: IFilter): Record<string, any> => {
  return Object.entries(filter)
    .filter(
      ([_, value]) =>
        value !== "" &&
        value !== "all" &&
        value !== undefined &&
        value !== null,
    )
    .reduce(
      (acc, [key, value]) => {
        acc[key] = value;
        return acc;
      },
      {} as Record<string, any>,
    );
};

export function formatStatus(status: string): string {
  return status
    .toLowerCase() // convert to lowercase
    .replace(/_/g, " ") // replace underscores with spaces
    .replace(/^\w/, (c) => c.toUpperCase()) // capitalize the first letter
    .replace(/\bof\b/g, "of"); // keep 'of' lowercase
}

// Helper function to format stat labels (camelCase to Title Case)
export const formatLabel = (key: string): string => {
  return key
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/_/g, " ") // replace underscores with spaces
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
    .trim();
};

export const formatRand = (
  value: number | string | null | undefined,
): string => {
  if (value === null || value === undefined || value === "") return "R0.00";

  const amount: number = typeof value === "string" ? Number(value) : value;

  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
    minimumFractionDigits: 2,
  }).format(isNaN(amount) ? 0 : amount);
};

export const firstLetterUpperCase = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn(
        "Clipboard API failed, falling back to legacy execution",
        err,
      );
    }
  }

  try {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; // Avoid scrolling
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    console.error("Fallback clipboard copy failed", err);
    return false;
  }
};

export const downloadExcel = async (url: string, filename: string) => {
  try {
    const token = getToken();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const rawData = await response.arrayBuffer();
    const blob = new Blob([rawData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Download error:", error);
    showToastNotification("danger", "Failed to download Excel file");
  }
};

export const permissionKeys = {
  dashboard: "show",
  company: "co",
  attendance: "attendance",
  // extraWork: 'ew',
  leave: "leave",
  regularization: "ar",
  wfh: "wfh",
  payslip: "paySlip",
  holiday: "holiday",
  hrmSetting: "hs",
  assets: "asts",
  forms: "forms",
  show: "show",
  site: "site",
  branch: "branch",
  od: "od",
};

export const menuBars = [
  { label: "Company", value: permissionKeys.company },
  // { label: 'Project', value: 'show' },
  // { label: 'Sites', value: 'show' },
  // { label: 'Site Salary Head', value: 'show' },

  { label: "Attendance", value: permissionKeys.attendance },
  { label: "Assets", value: permissionKeys.assets },
  // { label: 'My Attendance', value: 'attendance' },
  // { label: 'Daily Team Att.', value: 'attendance' },
  // { label: 'Monthly Team Att.', value: 'attendance' },

  // { label: 'Extra Work', value: 'ew' },
  // { label: 'My Extra Work', value: 'ew' },
  // { label: 'Team Extra Work', value: 'ew' },

  { label: "Leave", value: permissionKeys.leave },
  // { label: 'My Leave', value: 'leave' },
  // { label: 'Team Leave', value: 'leave' },

  { label: "Att. Regularization", value: permissionKeys.regularization },
  // { label: 'My A.R.', value: 'ar' },
  // { label: 'Team A.R.', value: 'ar' },

  { label: "WFH", value: permissionKeys.wfh },
  // { label: 'My O.D.', value: 'od' },
  // { label: 'Team O.D.', value: 'od' },

  // { label: 'Reimbursement', value: 'rf' },
  // { label: 'My Reimb.', value: 'rf' },
  // { label: 'Team Reimb.', value: 'rf' },

  { label: "Payslip", value: permissionKeys.payslip },
  // { label: 'My Payslip', value: 'paySlip' },
  // { label: 'Team Payslip', value: 'paySlip' },

  { label: "Holidays", value: permissionKeys.holiday },

  { label: "HRM Settings", value: permissionKeys.hrmSetting },
  { label: "Forms", value: permissionKeys.forms },
  { label: "Site", value: permissionKeys.site },
  { label: "Branch", value: permissionKeys.branch },
  { label: "Out Dore Duty", value: permissionKeys.od },
  // { label: 'Shift & Time Config', value: 'hs' },
  // { label: 'Employee Onboard', value: 'hs' },
  // { label: 'Salary Head', value: 'hs' },
  // { label: 'Holiday Setting', value: 'hs' },
  // { label: 'Office Location', value: 'hs' },
  // { label: 'Designation', value: 'hs' },
  // { label: 'Leave Setting', value: 'hs' },
  // { label: 'Site Salary Config', value: 'hs' },
  // { label: 'Deparment', value: 'hs' },

  // { label: 'Debit Note', value: 'dn' },
  // { label: 'TDS Ledger', value: 'tl' },
];
